import React, { CSSProperties, ReactElement } from 'react';

import styles from './ThumbBasic.scss';

export interface ThumbBasicProps {
  width?: number | string;
  height?: number | string;
  style?: CSSProperties;
  illustration: ReactElement;
  value?: any;
  className?: string;
  onClick?: (value: any) => any;
}

export class ThumbBasic extends React.Component<ThumbBasicProps> {
  render() {
    const {
      width,
      height = width,
      style = {},
      className = '',
      illustration,
      value,
      onClick,
    } = this.props;
    return (
      <div
        style={
          {
            '--thumb-basic-width':
              typeof width === 'number' ? `${width}px` : undefined,
            '--thumb-basic-height':
              typeof height === 'number' ? `${height}px` : undefined,
            ...style,
          } as React.CSSProperties
        }
        className={`${styles.thumbBasic} ${styles[className]}`}
        onClick={() => onClick?.(value)}
      >
        {illustration}
      </div>
    );
  }
  get value() {
    return this.props.value;
  }
}
